import { Modal } from "bootstrap";

export const showModal = ({ modalId }: { modalId: string }): void => {
  window.setTimeout(() => {
    const modal = new Modal(`#modal${modalId}`, { keyboard: true });
    modal.show();
  }, 50);
};
